import { InventoryItemTypeSpecification } from 'admin/inventory/InventoryItem'

export interface InventoryItemDto {
  id: string
  root_id?: string
  workspace_id?: string
  archived: boolean
  pro_visibility: InventoryItemProVisibility
  name: string
  description: string
  version: number
  courtesy_amount: number
  price: number
  pro_price: number
  created_by: string
  date_created: string | undefined
  short_id: string
  price_type: InventoryItemPriceType
  version_id: string
  supporting_items: SupportingItemDto[]
  document_signatures: DocumentSignatureItemDto[]
  type_specification: InventoryItemTypeSpecification
}

export enum InventoryItemPriceType {
  FLAT = 0,
  FEE = 1,
  MARKUP = 2,
  MARKDOWN = 3,
}

export interface SupportingItemDto {
  required: boolean
  spec: SupportingItemSpecDto
}

export type SupportingItemSpecDto =
  | SupportingItemDocumentSpecDto
  | SupportingItemPersonalInfoSpecDto
  | SupportingItemSpousalInfoSpecDto
  | SupportingItemDependentsInfoSpecDto
  | SupportingItemPersonalRefundMethodInfoSpecDto
  | SupportingItemBusinessInfoSpecDto
  | SupportingItemBusinessRefundMethodInfoSpecDto
  | SupportingItemNotesSpecDto

export interface SupportingItemDocumentSpecDto {
  type: SupportingItemSpecTypesDto.DOCUMENT
  document: {
    type_short_id: string
  }
}

export interface SupportingItemPersonalInfoSpecDto {
  type: SupportingItemSpecTypesDto.PERSONAL_INFO
}

export interface SupportingItemSpousalInfoSpecDto {
  type: SupportingItemSpecTypesDto.SPOUSAL_INFO
}

export interface SupportingItemDependentsInfoSpecDto {
  type: SupportingItemSpecTypesDto.DEPENDENTS_INFO
}

export interface SupportingItemPersonalRefundMethodInfoSpecDto {
  type: SupportingItemSpecTypesDto.PERSONAL_REFUND_METHOD_INFO
}

export interface SupportingItemBusinessInfoSpecDto {
  type: SupportingItemSpecTypesDto.BUSINESS_INFO
}

export interface SupportingItemBusinessRefundMethodInfoSpecDto {
  type: SupportingItemSpecTypesDto.BUSINESS_REFUND_METHOD_INFO
}

export interface SupportingItemNotesSpecDto {
  type: SupportingItemSpecTypesDto.NOTES
}

export interface DocumentSignatureItemDto {
  document_type_short_id: string
}

export enum SupportingItemSpecTypesDto {
  DOCUMENT,
  PERSONAL_INFO,
  SPOUSAL_INFO,
  DEPENDENTS_INFO,
  PERSONAL_REFUND_METHOD_INFO,
  BUSINESS_INFO,
  BUSINESS_REFUND_METHOD_INFO,
  NOTES,
}

export enum InventoryItemProVisibility {
  HIDDEN = 0,
  VISIBLE = 1,
}
